import React from 'react';

export function MetricCard({
  label,
  value,
  delta,
  hint,
}: {
  label: string;
  value: React.ReactNode;
  delta?: { text: string; direction: 'up' | 'down' | 'neutral' };
  hint?: string;
}) {
  return (
    <div className="metric-card">
      <div className="text-xs text-white/60 mb-1.5">{label}</div>
      <div className="text-2xl font-medium">{value}</div>
      {delta && (
        <div
          className={
            delta.direction === 'up'
              ? 'delta-up mt-1.5'
              : delta.direction === 'down'
              ? 'delta-down mt-1.5'
              : 'delta-neutral mt-1.5'
          }
        >
          {delta.text}
        </div>
      )}
      {hint && <div className="text-xs text-white/40 mt-1.5">{hint}</div>}
    </div>
  );
}

export function SectionHeader({
  title,
  hint,
  action,
}: {
  title: string;
  hint?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-baseline justify-between mb-3">
      <div>
        <div className="section-label !mb-0">{title}</div>
        {hint && <div className="text-xs text-white/40 mt-1">{hint}</div>}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({
  title,
  message,
  cta,
}: {
  title: string;
  message: string;
  cta?: React.ReactNode;
}) {
  return (
    <div className="raised-card text-center py-10">
      <div className="text-sm text-white/80 font-medium mb-1.5">{title}</div>
      <div className="text-xs text-white/50 max-w-md mx-auto leading-relaxed">{message}</div>
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}

export function ComingSoon({ source, reason }: { source: string; reason?: string }) {
  return (
    <EmptyState
      title={`${source} not yet wired`}
      message={
        reason ||
        `This section will populate once ${source} credentials are set in the Worker. See README for setup steps.`
      }
    />
  );
}
